<template>
  <div class="flex flex-wrap mb-2">
    <div ref="specialAdCategory" class="d2-panel-main bg-white rounded-xl space-y-6">
      <div>
        <span class="text-gray-700 align-middle">{{lang['components']['Event']['SpecialAdCategory']['title']}}</span>
        <i
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
          v-tooltip.top="lang['components']['Event']['SpecialAdCategory']['title_info']"
        ></i>
      </div>
      <div class="space-y-4">
        <select
          v-model="selectedCategory"
          :disabled="editPageType"
          class="w-full md:w-96 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="NONE">{{lang['components']['Event']['SpecialAdCategory']['none']}}</option>
          <option value="FINANCIAL_PRODUCTS_SERVICES">{{lang['components']['Event']['SpecialAdCategory']['financial']}}</option>
          <option value="EMPLOYMENT">{{lang['components']['Event']['SpecialAdCategory']['employment']}}</option>
          <option value="HOUSING">{{lang['components']['Event']['SpecialAdCategory']['housing']}}</option>
          <option value="ISSUES_ELECTIONS_POLITICS">{{lang['components']['Event']['SpecialAdCategory']['issues_elections']}}</option>
        </select>
      </div>
    </div>
    <div class="d2-panel-tips rounded-xl space-y-2 px-4"></div>
  </div>
</template>

<script>
export default {
  name: "SpecialAdCategory",
  components: {},
  props: {
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: String,
      default: 'NONE'
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      selectedCategory: 'NONE'
    };
  },
  watch:{
    'viewDatalist':function(v){
      this.selectedCategory = v || 'NONE'
    },
    selectedCategory (value){
      this.$emit('childSpecialAdCategory', value);
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
  },
  mounted() {
    if (this.viewDatalist) {
      this.selectedCategory = this.viewDatalist;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
